// extracted by mini-css-extract-plugin
export default {"block":"productlistblock_block__-YrtI"};